var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Task Reporting")]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying tasks reported")])]), _c('div', {
    staticClass: "col-sm-7 hidden-sm-down"
  }, [(_vm.userAccessLevel != "agent") ? _c('b-dropdown', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v("  Export")]), _c('b-dropdown-item', {
    attrs: {
      "type": "button",
      "variant": "info"
    },
    on: {
      "click": _vm.xlsx
    }
  }, [_vm._v("Download as xlsx")]), _c('b-dropdown-item', {
    attrs: {
      "type": "button",
      "variant": "info"
    },
    on: {
      "click": _vm.pdf
    }
  }, [_vm._v("Download as pdf")])], 2) : _c('b-button', {
    staticClass: "float-right",
    attrs: {
      "type": "button",
      "variant": "primary"
    },
    on: {
      "click": _vm.pdf
    }
  }, [_c('i', {
    staticClass: "icon-cloud-download"
  }), _vm._v(" Export as pdf")])], 1)]), _c('br'), _c('crm-table-tm')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0802c796","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CRM/tm.vue
// module id = 946
// module chunks = 1